import { createAction, props } from '@ngrx/store';

export const loadDownloadTermsAndConditions = createAction(
  '[DownloadTermsAndConditions] Load DownloadTermsAndConditions',
  props<{ documentName: string }>()
);

export const loadDownloadTermsAndConditionsSuccess = createAction('[DownloadTermsAndConditions] Load DownloadTermsAndConditions Success');

export const loadDownloadTermsAndConditionsFailure = createAction(
  '[DownloadTermsAndConditions] Load DownloadTermsAndConditions Failure',
  props<{ error: Error | any }>()
);
